/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeRiskActionRequest
 */
export interface InitiativeRiskActionRequest {
    /**
     * 
     * @type {string}
     * @memberof InitiativeRiskActionRequest
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeRiskActionRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the InitiativeRiskActionRequest interface.
 */
export function instanceOfInitiativeRiskActionRequest(value: object): value is InitiativeRiskActionRequest {
    return true;
}

export function InitiativeRiskActionRequestFromJSON(json: any): InitiativeRiskActionRequest {
    return InitiativeRiskActionRequestFromJSONTyped(json, false);
}

export function InitiativeRiskActionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeRiskActionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] == null ? undefined : json['note'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function InitiativeRiskActionRequestToJSON(json: any): InitiativeRiskActionRequest {
    return InitiativeRiskActionRequestToJSONTyped(json, false);
}

export function InitiativeRiskActionRequestToJSONTyped(value?: InitiativeRiskActionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
        'effectTenantId': value['effectTenantId'],
    };
}

